import {
  AirLock,
  Equipment,
  EquipmentListWrapper,
  EquipmentType,
  Extractor,
} from "@/models/equipment.model";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getEquipmentsByCategoryAndModelAndConstructor, getValuesDebit} from "@/services/equipment.service";
import EquipmentList from "./parts/EquipmentList/index.vue";
import CustomEquipmentSelector from "./parts/CustomEquipmentSelector/index.vue";
import { computed } from "@vue/composition-api";
import store from "@/store";


@Component({
  components: {
    EquipmentList,
    CustomEquipmentSelector,
  },
  
})

export default class EquipmentSelector extends Vue {
  @Prop() isMandatory!: boolean;
  @Prop() title!: string;
  @Prop() equipmentType!: EquipmentType;
  @Prop() categoryTitle!: string;

  equipmentList: Equipment[] = [];
  //Datas
  customEquipmentMode = false; //Linked to the button that allow user to switch between modes.

  defaultConstructorItem = this.$t(
    "components.equipmentPage.equipmentSelector.constructorSelection"
  ).toString();
  constructorFilter = this.defaultConstructorItem;
  constructorList: string[] = this.$t("global.constructorsList").toString().split(";");
  currentPage = 1;
  perPage = 100;
  busy = true;
  totalEquipmentCount = 0;

  modelFilter = "";

  created(): void {
    this.refreshEquipments();
  }

  /**
   * filter the list of equipment by model and constructor based on the search field
   */
  filterByModel(): void {
    this.refreshEquipments();
  }

  /**
   * Send the selected equipment to parent component
   * @param equipment selected equipment coming from child component
   */
  equipmentSelected(equipment: AirLock | Extractor | Equipment): void {
    this.$emit("equipmentSelected", equipment);
  }

  get breakpoint(): string {
    return this.$screen.breakpoint || "sm";
  }

  get pages(): number {
    // return this.totalEquipmentCount / this.perPage;
    return this.totalEquipmentCount / 4;
  }

  get baseDepression(): number {
    return store.state.settingsModule.settings.depressionValuetoMaintain;
  }
  @Watch("currentPage")
  onPageChange(): void {
    this.refreshEquipments();
  }
  

  private refreshEquipments() {
    this.busy = true;
    //currentPage pour ramener toutes les données
    const currentPage =1;
    getEquipmentsByCategoryAndModelAndConstructor(
      this.equipmentType,
      this.constructorFilter !== this.defaultConstructorItem ? this.constructorFilter : "",
      this.modelFilter,
      currentPage,
      this.perPage
    ).then((equipmentWrapper: EquipmentListWrapper) => {
      this.equipmentList = getValuesDebit( equipmentWrapper.equipmentList, this.baseDepression);
      this.totalEquipmentCount = equipmentWrapper.totalEquipmentCount;
      this.busy = false;
      this.paginate(this.currentPage,);
    });
  }

  //Paginationn remodified
  paginate(page: number) {
    const posts = this.equipmentList;
    const perPage = 4;
    const from = page * perPage - perPage;
    const to = page * perPage;
    const returnDatas = posts.slice(from, to);
    this.equipmentList = returnDatas;
  }

  /**
   * Create a new object equipment based on the 2 custom fields and send it to parent component.
   */
  saveCustomEquipment(customEquipment: Equipment | Extractor): void {
    this.$emit("equipmentSelected", customEquipment);
  }
}
